import { useState } from "react";
import { WelcomeBecomeMedic } from "./components/welcome-become-medic/welcome-become-medic";
import { FormBecomeMedic } from "./components/form-become-medic/form-become-medic";

export const BecomeMedic = ({ isNewsletterRequired, setAccess }) => {
  const [formOpen, setFormOpen] = useState(false);

  const graduate = () => {
    setFormOpen(true);
  };

  const closeForm = () => {
    setFormOpen(false);
  };

  return (
    <>
      {!formOpen && <WelcomeBecomeMedic graduate={graduate} />}
      {formOpen && (
        <FormBecomeMedic
          closeForm={closeForm}
          isNewsletterRequired={isNewsletterRequired}
          setAccess={setAccess}
        />
      )}
    </>
  );
};
